import React, { useRef } from 'react'
import TextEditor from '../../../../../../../../../../../shared-components/TextEditor';
import DropdownValueHandler from '../../../../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { useSelector } from 'react-redux';

const AdditionalInfo = ({ widgetUtilities, ...props }) => {
    const quillAdditionalInfoRef = useRef(null);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);

    const { 
        initialDataPatientName, initialDataAge, initialDataDOB, initialDataAddress, initialDataMobileNumber, initialDataEmail, 
        additionalInfoData, setAdditionalInfoData,
        AddDocument,
        setSaveDocumentData
        // handleDocumentDelete
    } = widgetUtilities;

    const handleChangeFreeText = (value, type) => {
        if (type === 'AdditionalInfo') {
            setAdditionalInfoData(prev => ({
                ...prev, "AdditionalInfoNotes": value,
            }));
        }
    }
    
    const handleDocumentDelete = (item, indexToRemove) => {
        const { PatientDocumentID, recordNoClient } = item;

        // Remove from EncounterDocument list by index
        setAdditionalInfoData(prev => {
            const updatedEncounterDocument = prev.EncounterDocument.filter((_, idx) => idx !== indexToRemove);
            return { ...prev, EncounterDocument: updatedEncounterDocument };
        });
        // Update saveDocumentData accordingly
        setSaveDocumentData(prev => {
            if (PatientDocumentID) {
                const exists = prev.some(doc => doc.PatientDocumentID === PatientDocumentID);

                if (exists) {
                    //  Update it to mark as deleted
                    return prev.map(doc =>
                        doc.PatientDocumentID === PatientDocumentID
                            ? { ...doc, Deleted: "true" }
                            : doc
                    );
                } else {
                    //  Push a new deleted object if it doesn't exist yet
                    return [
                        ...prev,
                        {
                            PatientDocumentID,
                            EncounterID: item.EncounterID,
                            Deleted: "true",
                        },
                    ];
                }
            } else if (recordNoClient) {
                //  Remove unsaved local doc entirely
                return prev.filter(doc => doc.recordNoClient !== recordNoClient);
            } else {
                return prev;
            }
        });
    }
  return (
    <div className="d-flex gap-10">
      <div className="ar-form-counter flex-center">
        <p className='text text-black'>{props?.itemCount}</p>
      </div>
      <div className='bg_yellow min-w-0 p-2 w-100' 
    // id={scrollNavIDs.refAdditionalINFO}
>
            <div className="ar_header d-flex gap-6 align-items-center" 
            // onClick={() => handleAccordionChange('AdditionalINFO')}
            >
                {/* {activeAccord['AdditionalINFO'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>} */}
                <p className="heading font-b fs-13 mb-1 leter-spacing">I - Additional INFO</p>
            </div>
            {/* {activeAccord['AdditionalINFO'] && */}
                <div className='d-flex flex-column gap-2 w-100 '>
                    {/* {defaultSelectedItems?.documents && */}
                        <div className='d-flex flex-column gap-6'>
                            <div className="d-flex justify-content-between align-items-center" 
                            // id={scrollNavIDs.refAdditionalINFODOC}
                            >
                                <p className="heading fs-13" 
                                // onClick={() => handleItemsExpanded('D')}
                                >Documents</p>
                                <div className="d-flex align-items-center gap-2">
                                    <div onClick={() => AddDocument({ PatientDocumentID: null })}>
                                        <i className="icon-dash-plus add-icon rounded-5 fs-20" ></i>
                                    </div>
                                </div>
                            </div>
                            {/* {!itemsCollapsed?.['D'] && ( */}
                                <>
                                {additionalInfoData?.EncounterDocument?.length > 0 &&
                                    <div className="py-2 px-1-5 assesment-box mb-1 d-flex flex-column gap-2">

                                        {additionalInfoData?.EncounterDocument.map((doc, index) => {
                                            let docType = DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)
                                            return (
                                                <>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <p className='text validate-color cursor-pointer text-nowrap br-right-1 br-clr-light pe-2' onClick={() => AddDocument(doc)}>{doc.FileName}</p>
                                                        <p className="text font-m text-nowrap">Document Type:</p>
                                                        <p className={`text text-nowrap pe-2 ${doc.Description ? 'br-right-1 br-clr-light' : ''} `}>{docType}</p>

                                                        {doc.Description ? <p className="text font-m text-nowrap">Description:</p> : <></>}
                                                        <p className='text text-nowrap validation_message w-100'>{doc.Description}</p>
                                                        <div className="d-flex gap-10 align-items-center ps-10">
                                                            <div className="lh-1">
                                                                <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleDocumentDelete(doc, index)}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>


                                            )
                                        })}
                                    </div>}
                            </>
                            {/* )} */}
                        </div>
                    {/* } */}
                    {/* {defaultSelectedItems?.additionalNotes && */}
                        <div className='d-flex flex-column gap-6'
                        //  id={scrollNavIDs.refAdditionalINFON} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refAdditionalINFON)} onClick={() => handleActiveItem(scrollNavIDs.refAdditionalINFON)}
                         >
                            <p className="heading fs-13" 
                            // onClick={() => handleItemsExpanded('IN')}
                            >Notes</p>
                            {/* {!itemsCollapsed?.['IN'] &&
                                ( */}
                                    <div className="">
                                        <TextEditor
                                            quillRef={quillAdditionalInfoRef}
                                            value={additionalInfoData.AdditionalInfoNotes}
                                            setValue={(value) => handleChangeFreeText(value, 'AdditionalInfo')}
                                            placeholderReplacement={true}
                                            customDropDown={{
                                                'active': true,
                                                'options': [
                                                    { value: initialDataPatientName, display: '$Name', },
                                                    { value: initialDataAge, display: '$Age', },
                                                    { value: initialDataDOB, display: '$DOB', },
                                                    { value: initialDataAddress, display: '$Address', },
                                                    { value: initialDataMobileNumber, display: '$Phone', },
                                                    { value: initialDataEmail, display: '$Email', },
                                                ]
                                            }}
                                        />
                                    </div>
                            {/* )} */}
                        </div>
                        {/* } */}
                </div>
            {/* } */}
        </div>
        </div>
  )
}

export default AdditionalInfo